import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';

export function useTransitionColors() {
  const enableNestedTransitionSwatchCookie = getCookieByName(
    'enableNestedTransitionSwatch',
    true
  );
  const enableNestedTransitionSwatchConfig = useSelector(
    (state: any) => state.config.layoutSettings?.enableNestedTransitionSwatch
  );

  const isNestedTransitionSwatchEnabled = useMemo(() => {
    if (![null, undefined].includes(enableNestedTransitionSwatchCookie)) {
      return enableNestedTransitionSwatchCookie as boolean;
    }
    if (![null, undefined].includes(enableNestedTransitionSwatchConfig)) {
      return enableNestedTransitionSwatchConfig as boolean;
    }
    return false;
  }, [enableNestedTransitionSwatchCookie, enableNestedTransitionSwatchConfig]);

  return {
    isNestedTransitionSwatchEnabled,
  };
}
